import * as React from 'react';
import type { SVGProps } from 'react';

const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M12.01 1.94 22 11.92l-9.98 9.98-2.12-2.12 6.3-6.3H2v-3h14.3L9.9 4.05 12 1.94z" />
  </svg>
);
export default SvgArrowRight;
